import { render, staticRenderFns } from "./billAdmin.vue?vue&type=template&id=178f49eb"
import script from "./billAdmin.vue?vue&type=script&lang=js"
export * from "./billAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports